import React, {useState} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import Icon from "@material-ui/core/Icon";
import Popup, {PopupContent} from "../../../../Common/Popup";
import {useTranslation} from "react-i18next";
import {isElitefoto} from "../../../../../lib/common";


const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.getContrastText(theme.palette.primary.main),
    border: 'none',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '24px',
    fontSize: '16px',
    fontWeight: 'bold',
    marginBottom: theme.spacing(3)
  },
  stateList: {
    padding: 0,
    margin: 0,
    listStyle: 'none',
    textAlign: 'left',
    width: 'calc(90vw - 30px)',
    '& > li': {
      borderBottom: '1px solid #ccc',
      height: '64px',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'start',
      justifyContent: 'center'
    }
  },
  pickupRegion: {
    fontSize: '24px',
    fontWeight: 'bold',
    marginTop: theme.spacing(2)
  },
  pickupCity: {
    fontSize: '20px',
    fontWeight: 'bold'
  },
  shopName: {
    fontSize: '16px',
    fontWeight: 'normal'
  }
}));

const Select = ({deliveryType, setPickupLocation, onClose}) => {
  const classes = useStyles();

  const regions = deliveryType.pickupLocations.reduce((regions, pickupLocation) => {

    // Hide express choices and no region:
    console.log(pickupLocation.uuid, pickupLocation.uuid.substring(24));
    if ((isElitefoto() && !pickupLocation.pickupregion) || pickupLocation.uuid.substring(24) === "111111111111") {
      console.log('Skipping')
      return regions;
    }

     let region = regions.find(s => {
       console.log('Compare', s.region, pickupLocation.pickupregion, pickupLocation);
       return s.region === pickupLocation.pickupregion
     });
     if (!region) {
        region = {
          region: pickupLocation.pickupregion,
          pickupLocations: []
        };
        regions.push(region)
     }


     region.pickupLocations.push(pickupLocation);

     return regions;
  }, [])

  regions.sort((a, b) => {
    return a.region.localeCompare(b.region);
  });

  return <Popup onClose={onClose}>
    <PopupContent>
      <ul className={classes.stateList}>
      {regions.map((region) => {
        region.pickupLocations.sort((a, b) => {
          console.log('CMp', a);
          const cmp = a.pickupcity.localeCompare(b.pickupcity);
          if (cmp !== 0) {
            return cmp;
          }
          return a.description.localeCompare(b.description);
        })
        return <React.Fragment key={region.region}>
          <li className={classes.pickupRegion}>{region.region}</li>
          {region.pickupLocations.map(pickupLocation => {
            return <li key={pickupLocation.uuid} role='button' onClick={() => setPickupLocation(pickupLocation)}>
              <div className={classes.pickupCity}>{pickupLocation.pickupcity}</div>
              <div className={classes.shopName}>{pickupLocation.description}</div>
            </li>
          })}
          </React.Fragment>
      })}
      </ul>
    </PopupContent>
  </Popup>
}


export default ({deliveryType, setPickupLocation, pickupLocation}) => {
  const [showSelection, setShowSelection] = useState(false)
  const classes = useStyles();
  const {t} = useTranslation();

  const handleSetPickupLocation = (pickupLocation) => {
    setPickupLocation(pickupLocation);
    setShowSelection(false);
  }
  console.log('Delivery type', deliveryType);

  return <button className={classes.root} onClick={() => setShowSelection(true)}>
    <span>{pickupLocation ?  pickupLocation.description :  t('Choose store')}</span>
    <Icon>expand_more</Icon>
    {showSelection && <Select deliveryType={deliveryType} setPickupLocation={handleSetPickupLocation} onClose={() => setShowSelection(false)}/>}
  </button>
}